import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EbrCoreModule } from 'src/app/core/components/ebr-core.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { AppRoutingModule } from 'src/app/app-routing.module';
import {MatFormFieldModule} from '@angular/material/form-field';
import { MatTableModule } from '@angular/material/table';
import { MatButton, MatButtonModule } from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatSelectModule} from '@angular/material/select';
import { NgxEchartsModule } from 'ngx-echarts';
import {MatDialogModule} from '@angular/material/dialog';
import { ReactiveFormsModule} from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { ServiceInsightsComponent } from './service-insights.component';
import { LocationInsightsTableComponent } from './components/location-insights-table/location-insights-table.component';
import { ServiceMetricLineChartComponent } from './components/service-metric-line-chart/service-metric-line-chart.component';
import { ServiceMetricDonutChartComponent } from './components/service-metric-donut-chart/service-metric-donut-chart.component';
import { MatSortModule } from '@angular/material/sort';
import { ImplicationDialogComponent } from './components/implication-dialog/implication-dialog.component';
import { LocationsDialogComponent } from './components/locations-dialog/locations-dialog.component';
import { ImplicationEditFieldComponent } from './components/implication-edit-field/implication-edit-field.component';
import { ServiceInsightsTableComponent } from './components/service-insights-table/service-insights-table.component';
import {DragDropModule } from '@angular/cdk/drag-drop';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ServiceDetailsTableComponent } from './components/service-details-table/service-details-table.component';
import { ServiceDetailsCallsComponent } from './components/service-details-calls/service-details-calls.component';
import { BaseChartDirective } from 'ng2-charts';
import { ServiceDetailsCommonChartComponent } from './components/service-details-common-chart/service-details-common-chart.component';
import { PhotosTable } from './components/photos-table/photos-table.component';
import { PhotosViewWindow } from './components/photos-view-window/photos-view-window.component';
import { ServiceInsightsPhotoGalleryComponent } from './components/export-photo/service-insights-photo-gallery.component';
import { ServiceInsightsPhotoGalleryItemComponent } from './components/export-photo/service-insights-photo-gallery-item/service-insights-photo-gallery-item.component';
import { ServiceInsightsPhotoCarouselComponent } from './components/export-photo/service-insights-photo-carousel/service-insights-photo-carousel.component';
import { PestServiceInsightsComponent } from './components/pest-service-insights/pest-service-insights.component';
import { ServiceInsightsKpiBarComponent } from './components/service-insights-kpi-bar/service-insights-kpi-bar.component';
import { ServiceMetricCardComponent } from './components/service-metric-card/service-metric-card.component';
import { ObservationsKpiCardComponent } from './components/service-insights-table/observations-kpi-card/observations-kpi-card.component';
import { ServiceKpiCardComponent } from './components/service-kpi-card/service-kpi-card.component';
import { ServiceCallDistributionChartComponent } from './components/service-call-distribution-chart/service-call-distribution-chart.component';
import { ServiceDetailsMetricCardComponent } from './components/service-details-calls/service-details-metric-card/service-details-metric-card.component';
import { PhotoCardComponent } from './components/photos-table/photo-card/photo-card.component';
import { ServiceDetailsIssuesFilterComponent } from './components/service-details-issues-filter/service-details-issues-filter.component';
import { ServiceCallTypeLabelPipe } from './pipes/service-call-type-label.pipe';
import { ServiceDetailsKpiCardsComponent } from './components/service-details-kpi-cards/service-details-kpi-cards.component';

@NgModule({
  declarations: [
    ServiceInsightsComponent,
    LocationInsightsTableComponent,
    ServiceMetricLineChartComponent,
    ServiceMetricDonutChartComponent,
    ImplicationDialogComponent,
    ImplicationEditFieldComponent,
    ServiceInsightsTableComponent,
    LocationsDialogComponent,
    ServiceDetailsCallsComponent,
    ServiceDetailsTableComponent,
    PhotosTable,
    PhotosViewWindow,
    ServiceDetailsCommonChartComponent,
    ServiceInsightsPhotoGalleryComponent,
    ServiceInsightsPhotoGalleryItemComponent,
    ServiceInsightsPhotoCarouselComponent,
    PestServiceInsightsComponent,
    ServiceInsightsKpiBarComponent,
    ServiceMetricCardComponent,
    ObservationsKpiCardComponent,
    ServiceKpiCardComponent,
    ServiceCallDistributionChartComponent,
    ServiceDetailsMetricCardComponent,
    PhotoCardComponent,
    ServiceDetailsIssuesFilterComponent,
    ServiceCallTypeLabelPipe,
    ServiceDetailsKpiCardsComponent,
  ],
  exports: [
    ServiceInsightsComponent,
    ServiceInsightsPhotoGalleryComponent
  ],
  imports: [
    EbrCoreModule,
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    MatFormFieldModule,
    MatTableModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatSelectModule,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts')
    }),
    MatDialogModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSortModule,
    AppRoutingModule,
    MatIconModule,
    DragDropModule,
    MatPaginatorModule,
    BaseChartDirective,
    SharedModule
  ]
})
export class ServiceInsightsModule { }


